var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _polygon, _polygon2, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path3, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Uebersetzungen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 9.18,
    width: 22.31,
    height: 4.62,
    fill: "#05548e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 13.8,
    width: 22.31,
    height: 4.62,
    fill: "#b4ccdd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 18.42,
    width: 22.31,
    height: 4.62,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,21V65H75V21ZM73,63H37V23H73Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.06,45H39.75V29.28H63.06ZM40.75,44H62.06V30.28H40.75Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 47.81,
    width: 22.31,
    height: 3.81,
    transform: "translate(82.13 78.44) rotate(180)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.89,
    y: 47.64,
    width: 15.34,
    height: 3.81,
    transform: "translate(73.11 -30.02) rotate(90)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.48,
    y: 21.53,
    width: 22.24,
    height: 14.51,
    fill: "#05548e"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.67 35.88 34.68 23.75 34.79 21.37 34.01 21.37 12.48 33.81 12.57 35.63 13.67 35.88",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "12.33 23.02 33.3 35.81 34.58 35.44 34.52 33.82 13.55 21.03 12.56 21.71 12.33 23.02",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 48.56,
    width: 22.31,
    height: 2.38,
    transform: "translate(82.13 78.5) rotate(180)",
    fill: "#b4ccdd"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51.23,
    y: 48.52,
    width: 14.67,
    height: 2.38,
    transform: "translate(73.27 -29.86) rotate(90)",
    fill: "#b4ccdd"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.44,
    y: 46.2,
    width: 13.66,
    height: 0.9,
    transform: "translate(39.47 93.22) rotate(-148.63)",
    fill: "#b4ccdd"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 56.98,
    y: 51.88,
    width: 13.66,
    height: 0.85,
    transform: "translate(56.07 109.18) rotate(-148.63)",
    fill: "#b4ccdd"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 46.67,
    y: 52.66,
    width: 14.01,
    height: 0.8,
    transform: "translate(91.73 51.01) rotate(149.88)",
    fill: "#b4ccdd"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56.98,
    y: 45.93,
    width: 13.66,
    height: 0.77,
    transform: "matrix(-0.86, 0.5, -0.5, -0.86, 107.26, 33.36)",
    fill: "#b4ccdd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.22,57.54H46.91V41.87H70.22Zm-22.31-1H69.22V42.87H47.91Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 47.81,
    width: 9.97,
    height: 0.75,
    transform: "translate(69.79 75.37) rotate(180)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 59.75,
    y: 47.81,
    width: 9.63,
    height: 0.75,
    transform: "translate(94.13 75.37) rotate(180)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 50.94,
    width: 9.97,
    height: 0.75,
    transform: "translate(69.79 81.62) rotate(180)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 59.75,
    y: 50.94,
    width: 9.63,
    height: 0.75,
    transform: "translate(94.13 81.62) rotate(180)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 45.26,
    width: 5.85,
    height: 0.75,
    transform: "translate(70.76 -35.49) rotate(90)",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 53.49,
    width: 5.85,
    height: 0.75,
    transform: "translate(78.99 -27.26) rotate(90)",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 54.07,
    y: 53.49,
    width: 5.85,
    height: 0.75,
    transform: "translate(75.87 -24.14) rotate(90)",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 54.07,
    y: 45.26,
    width: 5.85,
    height: 0.75,
    transform: "translate(67.64 -32.37) rotate(90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateDefault);
export default __webpack_public_path__ + "static/media/translate-default.967da1345afb4a37dedbdffc305014ef.svg";
export { ForwardRef as ReactComponent };